import { ArrowLeft, ArrowRight } from 'lucide-react'
import { Row } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const NavigationButtons = ({ onPrevious, onNext }) => {
  const { t } = useLocalization()

  return (
    <Row className="gap-2 shrink-0">
      <button
        type="button"
        onClick={onPrevious}
        className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white text-slate-600 transition-colors hover:bg-gray-50"
        aria-label={t('Previous testimonials', 'Föregående omdömen')}
      >
        <ArrowLeft className="h-4 w-4" strokeWidth={1.5} />
      </button>
      <button
        type="button"
        onClick={onNext}
        className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white text-slate-600 transition-colors hover:bg-gray-50"
        aria-label={t('Next testimonials', 'Nästa omdömen')}
      >
        <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
      </button>
    </Row>
  )
}
